import Modal from 'trunks/vue/admin/components/modals/modal.js';
import ResponseImportModelModal from 'trunks/vue/admin/compositions/response_import/response_import_model.js';
import ResponseImportModalMixin from 'trunks/vue/admin/compositions/response_import/response_import_modal_mixin.js';

export default Vue.extend({
  mixins: [ResponseImportModalMixin],

  components: {
    modal: Modal,
    'import-model-modal': ResponseImportModelModal,
  },

  data() {
    return {
      downloadTemplateUrl: `${location.pathname}/download_template.xlsx`,
      importRecordsUrl: `${location.pathname}_import_records`,
    };
  },

  template: `
    <modal title="数据导入" ref="modal" :extendClass='"responses-import-modal"'>
      <import-model-modal :uploadRequest='uploadRequest'
                          :requestError='requestError'
                          :requestSuccess='requestSuccess'
                          :file='file'
                          @closeUploadMask='closeUploadMaskFunc'
                          @removeFile='removeFileFunc'>
        <template slot="importRecords">
          <a :href='importRecordsUrl' class="btn-link gray-text ml-1 mr-1">导入记录-导入填写记录</a>
        </template>

        <template slot="fileUpload">
          <input type="file"
                 accept=".xlsx"
                 hidden='true'
                 @change='filesChangedFunc'
                 ref="uploadInput"/>
        </template>

        <template slot="tips">
          <div class="response-import-tip-list">
            <div class="response-import-tip-list-item light-gray-text ml-5">
              支持 xls、xlsx 文件
            </div>
            <div class="response-import-tip-list-item light-gray-text ml-5">
              文件大小不超过5M
            </div>
          </div>
        </template>

        <template slot="downloadTemplate">
          <a :href="downloadTemplateUrl" class="gray-link" target="_blank" download="导入模板.xlsx">点击下载导入模板</a>
        </template>
      </import-model-modal>
      <div class="modal-footer" slot='footer'>
        <button class="outlined btn-default" :disabled="requestSuccess" @click='cancel'>取消</button>
        <button :disabled="buttonDisabled" @click='ensureClick'>确定</button>
      </div>
    </modal>
  `,
});
